import { useMasterDataRetailers } from "@src/presentation/providers/MasterDataRetailersDataProvider";
import { MasterDataListFooter } from "./MasterDataListFooter";

export const MasterDataRetailersFooter = () => {
  const { total, page, limit, loading, setPage } = useMasterDataRetailers();

  return (
    <MasterDataListFooter
      total={total}
      page={page}
      limit={limit}
      loading={loading}
      onPageChange={setPage}
      ariaLabel="Retailers Pagination"
    />
  );
};
